import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'
import get from 'lodash/get'
import round from 'lodash/round'

import { ActionablesContext } from '../../../../../contexts/ActionablesContext'
import { CardContent, CardHeading, CardFooter } from '../../../../../components/layout/Card'
import { CueCard, CueCardItem } from '../../../../../components/CueCard'
import { Button } from '../../../../../components/Button'
import { Spotlight } from '../../../../../components/Spotlight'
import { R, sumCurrency } from '../../../../../utils/currency'
import { FnaContext } from '../../../context'
import { ASSESSMENT_TYPE } from '../../../reducer'

export const Show = () => {
  const {
    state: {
      fna: {
        [ASSESSMENT_TYPE.INCOME_PROTECTION]: assessment
      },
      onCreateNewScenario,
      budget
    },
    actions: { goToUpdateForm, goToIndex, goToDelete }
  } = useContext(FnaContext)

  const { fnaReadOnly } = useContext(ActionablesContext)
  const grossMonthlyCurrentIncome = get(budget, 'gross_monthly_current_income', null)
  const replacementRatio = (grossMonthlyCurrentIncome && grossMonthlyCurrentIncome !== 0)
    ? `${round((R(get(assessment, 'total_monthly_expenses', 0)).value / R(grossMonthlyCurrentIncome).value) * 100, 2)}%`
    : null

  const incomeProtectionBalance = R(get(assessment, 'balance', 0)).value

  return (
    <>
      <CardContent>
        <Box
          px='3rem'
          my='1rem'
          display='flex'
          justifyContent='space-between'
        >
          <Spotlight
            value={sumCurrency([get(assessment, 'existing_cover', 0), get(assessment, 'total_from_selected_risk_products', 0)]).format()}
            description={`Existing cover`} />
          <Spotlight
            value={R(get(assessment, 'total_monthly_expenses', 0)).format()}
            description={`Required Cover`} />
          {replacementRatio &&
            <Spotlight
              value={replacementRatio}
              description={'Replacement ratio'}
            />
          }
          <Spotlight
            value={R(get(assessment, 'balance', 0)).format()}
            description={incomeProtectionBalance < 0 ? 'Shortfall' : 'Surplus'}
          />
        </Box>
        <Box
          display='flex'
        >
          <Box
            m='1rem'
            width='50%'
          >
            <CueCard>
              <CardHeading>
                <h3>Things to pay for over time</h3>
              </CardHeading>
              <CardContent>
                <CueCardItem
                  name='Monthly budget'
                  value={R(get(assessment, 'monthly_budget_expenses', 0)).format()}
                />
                <CueCardItem
                  name='Total asset contributions'
                  value={R(get(assessment, 'total_asset_monthly_contributions', 0)).format()}
                />
              </CardContent>
            </CueCard>
          </Box>
        </Box>
      </CardContent>
      <CardFooter className='gap-4'>
        {!fnaReadOnly &&
          <Button trackAs="Income protection: Delete" tertiary onClick={goToDelete(ASSESSMENT_TYPE.INCOME_PROTECTION)}>Delete assessment</Button>
        }
        <Button secondary onClick={goToIndex}>Go back</Button>
        {!fnaReadOnly &&
          <Button trackAs="Income protection: Retake" onClick={goToUpdateForm(ASSESSMENT_TYPE.INCOME_PROTECTION)} primary>Retake assessment</Button>
        }
        {fnaReadOnly &&
          <Button
            primary
            trackAs="Income protection: Create new scenario"
            onClick={() => onCreateNewScenario()}
          >
            Retake in scenario planning
          </Button>
        }
      </CardFooter>
    </>
  )
}
